(() => {
  let libraryPromise;
  let scanAudio;
  function prepareScanSound() {
    try {
      const Audio = window.AudioContext || window.webkitAudioContext;
      if (!Audio) return;
      if (!scanAudio || scanAudio.state === 'closed') scanAudio = new Audio();
      scanAudio.resume().catch(() => {});
    } catch {}
  }
  function scanSound() {
    try {
      if (scanAudio?.state !== 'running') return;
      const tone = scanAudio.createOscillator();
      const volume = scanAudio.createGain();
      tone.frequency.value = 1200;
      const now = scanAudio.currentTime;
      volume.gain.setValueAtTime(0.12, now);
      volume.gain.exponentialRampToValueAtTime(0.001, now + 0.12);
      tone.connect(volume); volume.connect(scanAudio.destination);
      tone.onended = () => { tone.disconnect(); volume.disconnect(); };
      tone.start(now); tone.stop(now + 0.13);
    } catch {}
  }
  function loadScanner() {
    if (window.ZXingBrowser) return Promise.resolve();
    if (libraryPromise) return libraryPromise;
    libraryPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timer = setTimeout(() => fail(), 20000);
      function fail() { clearTimeout(timer); script.remove(); libraryPromise = null; reject(new Error('library')); }
      script.src = 'https://cdn.jsdelivr.net/npm/@zxing/browser@0.1.5/umd/zxing-browser.min.js';
      script.async = true;
      script.onload = () => { clearTimeout(timer); if (window.ZXingBrowser) resolve(); else fail(); };
      script.onerror = fail;
      document.head.append(script);
    });
    return libraryPromise;
  }
  function equalCode(a, b) {
    const normalize = value => {
      const code = String(value ?? '').trim();
      return /^0\d{12}$/.test(code) ? code.slice(1) : code;
    };
    return normalize(a) !== '' && normalize(a) === normalize(b);
  }
  function syncLock() {
    document.documentElement.classList.toggle('cs-modal-open', !!document.querySelector('.cs-dialog[open]'));
  }
  class CaslandSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.searchDialog = this.querySelector('[data-search-dialog]');
      this.scannerDialog = this.querySelector('[data-scanner-dialog]');
      this.input = this.querySelector('[data-query]');
      this.results = this.querySelector('[data-results]');
      this.status = this.querySelector('[data-status]');
      this.cameraStatus = this.querySelector('[data-camera-status]');
      this.readerElement = this.querySelector('[data-reader]');
      this.all = this.querySelector('[data-all]');
      this.root = this.dataset.root.replace(/\/?$/, '/');
      this.sequence = 0;
      this.cameraSequence = 0;
      this.cameraTask = Promise.resolve();
      this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      this.querySelector('[data-search-open]').addEventListener('click', event => {
        if (!this.searchDialog.showModal) return;
        event.preventDefault();
        this.searchDialog.showModal(); syncLock(); this.input.focus();
      });
      this.querySelector('[data-search-close]').addEventListener('click', () => this.searchDialog.close());
      this.searchDialog.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.searchDialog.close(); }
      });
      this.searchDialog.addEventListener('close', () => { this.cancelSearch(); this.closeScanner(); syncLock(); });
      this.input.addEventListener('input', () => {
        this.cancelSearch();
        const query = this.input.value.trim();
        this.results.replaceChildren(); this.status.textContent = ''; this.all.hidden = true;
        if (query) this.timer = setTimeout(() => this.search(query, false), 250);
      });
      this.querySelector('[data-name-form]').addEventListener('submit', event => {
        if (!this.input.value.trim()) event.preventDefault();
      });
      this.querySelector('[data-camera]').addEventListener('click', () => this.openScanner());
      this.querySelector('[data-scanner-close]').addEventListener('click', () => this.closeScanner());
      this.scannerDialog.addEventListener('cancel', event => { event.preventDefault(); this.closeScanner(); });
      this.scannerDialog.addEventListener('close', () => { syncLock(); });
      this.scannerDialog.addEventListener('keydown', event => { if (event.key === 'Escape') event.stopPropagation(); });
      this.querySelector('[data-code-form]').addEventListener('submit', event => {
        event.preventDefault();
        const code = this.querySelector('[data-code]').value.trim();
        if (code) this.acceptCode(code);
      });
      this.onPageHide = () => this.closeScanner();
      this.onVisibility = () => { if (document.hidden) this.closeScanner(); };
      window.addEventListener('pagehide', this.onPageHide);
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() {
      this.cancelSearch(); this.closeScanner();
      window.removeEventListener('pagehide', this.onPageHide);
      document.removeEventListener('visibilitychange', this.onVisibility);
      syncLock();
    }
    cancelSearch() {
      clearTimeout(this.timer); this.sequence++;
      this.controller?.abort(); this.results?.removeAttribute('aria-busy');
    }
    async json(url, signal) {
      const controller = new AbortController();
      const abort = () => controller.abort();
      if (signal?.aborted) controller.abort();
      signal?.addEventListener('abort', abort, { once: true });
      const timer = setTimeout(abort, 15000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        return await response.json();
      } finally { clearTimeout(timer); signal?.removeEventListener('abort', abort); }
    }
    productUrl(handle) { return this.root + 'products/' + encodeURIComponent(handle); }
    async search(query, byCode) {
      this.cancelSearch();
      const sequence = this.sequence;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.results.replaceChildren(); this.results.setAttribute('aria-busy', 'true');
      this.status.textContent = this.messages.loading;
      const allURL = new URL(this.root + 'search', location.origin);
      allURL.searchParams.set('q', query); allURL.searchParams.set('type', 'product');
      this.all.href = allURL.href; this.all.hidden = false;
      try {
        const url = new URL(this.root + 'search/suggest.json', location.origin);
        url.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': byCode ? '10' : '6', 'resources[options][unavailable_products]': 'last' }).toString();
        const data = await this.json(url, signal);
        const suggestions = data.resources.results.products;
        const products = [];
        let failed = false;
        for (let i = 0; i < suggestions.length; i += 3) {
          if (signal.aborted) return;
          const group = await Promise.allSettled(suggestions.slice(i, i + 3).map(p => this.json(this.productUrl(p.handle) + '.js', signal)));
          group.forEach((result, offset) => {
            if (result.status === 'fulfilled') products.push({ product: result.value, suggestion: suggestions[i + offset] });
            else failed = true;
          });
        }
        if (sequence !== this.sequence || signal.aborted || !this.searchDialog.open) return;
        const matches = byCode ? products.flatMap(({ product }) =>
          product.variants.filter(v => equalCode(v.barcode, query)).map(variant => ({ product, variant }))) : [];
        if (byCode && matches.length && new Set(matches.map(match => match.product.handle)).size === 1 && !failed) {
          const { product, variant } = matches[0];
          location.assign(this.productUrl(product.handle) + (matches.length === 1 ? '?variant=' + encodeURIComponent(variant.id) : ''));
          return;
        }
        let count = 0;
        let truncated = false;
        for (const { product, suggestion } of products) {
          truncated ||= product.variants.length >= 250;
          if (byCode) {
            for (const variant of product.variants.filter(v => equalCode(v.barcode, query))) {
              this.renderProduct(product, variant); count++;
            }
          } else {
            const candidateURL = new URL(suggestion.url, location.origin);
            const variantId = candidateURL.searchParams.get('variant');
            const variant = variantId ? product.variants.find(v => String(v.id) === variantId) : null;
            this.renderProduct(product, variant); count++;
          }
        }
        if (count) this.status.textContent = `${this.messages.results}: ${count}${failed ? '. ' + this.messages.incomplete : ''}`;
        else if (failed) this.status.textContent = this.messages.error;
        else if (byCode && (truncated || suggestions.length === 10)) this.status.textContent = this.messages.incomplete;
        else this.status.textContent = byCode ? this.messages.missing : this.messages.empty;
      } catch (error) {
        if (sequence === this.sequence && !signal.aborted) this.status.textContent = this.messages.error;
      } finally {
        if (sequence === this.sequence) this.results.removeAttribute('aria-busy');
      }
    }
    renderProduct(product, variant) {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'cs-result';
      link.href = this.productUrl(product.handle) + (variant ? '?variant=' + variant.id : '');
      const source = variant?.featured_image?.src || product.featured_image;
      if (source) {
        const imageURL = new URL(source, location.origin);
        if (imageURL.protocol === 'https:') {
          imageURL.searchParams.set('width', '128');
          const img = document.createElement('img');
          img.src = imageURL.href; img.alt = ''; img.width = 64; img.height = 80; img.loading = 'lazy';
          link.append(img);
        }
      }
      const info = document.createElement('span'); info.className = 'cs-result-info';
      const line = (text, className) => {
        const el = document.createElement('span'); el.textContent = text;
        if (className) el.className = className;
        info.append(el);
      };
      line(product.title);
      const sizeIndex = product.options.findIndex(option => /^(tallas?|sizes?|tamaños?|n[uú]meros?)$/i.test(String(option.name || option).trim()));
      if (sizeIndex >= 0) {
        const variants = variant ? [variant] : product.variants;
        const sizes = [...new Set(variants.map(v => v.options[sizeIndex]).filter(Boolean))];
        if (sizes.length) line(this.messages.sizes + ': ' + sizes.join(', '));
      }
      const price = variant ? variant.price : product.price_min;
      const max = variant ? variant.price : product.price_max;
      line(this.money.format(price / 100) + (max > price ? ' – ' + this.money.format(max / 100) : ''), 'cs-result-price');
      if (!(variant ? variant.available : product.available)) line(this.messages.sold_out);
      link.append(info); li.append(link); this.results.append(li);
    }
    async openScanner() {
      if (this.scannerDialog.open) return;
      prepareScanSound();
      this.cancelSearch(); this.status.textContent = '';
      this.scannerDialog.showModal(); syncLock();
      this.querySelector('[data-scanner-close]').focus();
      this.cameraStatus.textContent = this.messages.starting;
      const sequence = ++this.cameraSequence;
      if (!window.isSecureContext || !navigator.mediaDevices?.getUserMedia) {
        this.cameraStatus.textContent = this.messages.unsupported; return;
      }
      try { await loadScanner(); }
      catch { if (sequence === this.cameraSequence) this.cameraStatus.textContent = this.messages.library_error; return; }
      if (sequence !== this.cameraSequence || !this.scannerDialog.open) return;
      this.cameraTask = this.cameraTask.catch(() => {}).then(async () => {
        if (sequence !== this.cameraSequence || !this.scannerDialog.open) return;
        const formats = window.ZXingBrowser.BarcodeFormat;
        // ZXing DecodeHintType.TRY_HARDER = 3 in the pinned library.
        const hints = new Map([[3, true]]);
        const decoder = new window.ZXingBrowser.BrowserMultiFormatReader(hints, {
          delayBetweenScanAttempts: 120, delayBetweenScanSuccess: 500
        });
        decoder.possibleFormats = [formats.EAN_13, formats.EAN_8, formats.UPC_A,
          formats.CODE_128, formats.ITF, formats.QR_CODE];
        const video = document.createElement('video');
        video.muted = true; video.autoplay = true; video.playsInline = true;
        this.readerElement.replaceChildren(video);
        let controls;
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
              facingMode: { ideal: 'environment' },
              width: { ideal: 1920 }, height: { ideal: 1080 }
            }
          });
          let running = true;
          let timer;
          controls = { stop: () => {
            running = false; clearTimeout(timer);
            stream.getTracks().forEach(track => track.stop());
            video.srcObject = null;
          }};
          this.reader = controls;
          if (sequence !== this.cameraSequence || !this.scannerDialog.open) {
            await this.releaseReader(controls); return;
          }
          video.srcObject = stream;
          await video.play();
          if (sequence !== this.cameraSequence || !this.scannerDialog.open) await this.releaseReader(controls);
          else {
            this.cameraStatus.textContent = this.messages.ready;
            await this.setupCameraControls(sequence).catch(() => {});
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d', { willReadFrequently: true });
            let rotate = false;
            const readFrame = () => {
              if (!running || sequence !== this.cameraSequence || !this.scannerDialog.open) return;
              if (video.readyState >= 2 && video.videoWidth && context) {
                const width = video.videoWidth, height = video.videoHeight;
                canvas.width = rotate ? height : width;
                canvas.height = rotate ? width : height;
                if (rotate) { context.translate(height, 0); context.rotate(Math.PI / 2); }
                context.drawImage(video, 0, 0, width, height);
                rotate = !rotate;
                try {
                  const code = decoder.decodeFromCanvas(canvas).getText();
                  scanSound(); controls.stop(); this.acceptCode(code); return;
                } catch { /* No readable barcode in this frame. */ }
              }
              timer = setTimeout(readFrame, 140);
            };
            readFrame();
          }
        } catch (error) {
          if (controls) await this.releaseReader(controls);
          else { this.stopTracks(); this.readerElement.replaceChildren(); }
          if (sequence !== this.cameraSequence) return;
          const description = `${error?.name || ''} ${error}`;
          this.cameraStatus.textContent = /NotAllowed|Permission|denied/i.test(description) ? this.messages.permission : this.messages.camera_error;
        }
      });
    }
    async setupCameraControls(sequence) {
      const video = this.readerElement.querySelector('video');
      const track = video?.srcObject?.getVideoTracks()[0];
      if (!track || !track.getCapabilities) return;
      const capabilities = track.getCapabilities();
      if (capabilities.focusMode?.includes('continuous')) {
        try { await track.applyConstraints({ advanced: [{ focusMode: 'continuous' }] }); } catch {}
      }
      if (sequence !== this.cameraSequence || !this.scannerDialog.open) return;
      const controls = document.createElement('div');
      controls.className = 'cs-camera-controls';
      this.cameraControls = controls;
      const button = (label, action) => {
        const element = document.createElement('button');
        element.type = 'button'; element.className = 'button button--secondary';
        element.textContent = label; element.setAttribute('aria-label', label);
        element.addEventListener('click', async () => {
          element.disabled = true;
          try { await action(element); }
          catch { this.cameraStatus.textContent = 'No se pudo ajustar la cámara. Puedes seguir escaneando.'; }
          finally { element.disabled = false; }
        });
        controls.append(element); return element;
      };
      if (capabilities.zoom && capabilities.zoom.max > capabilities.zoom.min) {
        const minimum = capabilities.zoom.min;
        const maximum = capabilities.zoom.max;
        const step = capabilities.zoom.step || 0.1;
        const levels = [...new Set([1, 1.5, 2].map(value =>
          Math.min(maximum, Math.max(minimum, minimum + Math.round((value - minimum) / step) * step))))];
        levels.forEach(zoom => button(`${zoom.toFixed(1)}×`, async element => {
          await track.applyConstraints({ advanced: [{ zoom }] });
          controls.querySelectorAll('[data-zoom]').forEach(b => b.setAttribute('aria-pressed', String(b === element)));
        }).setAttribute('data-zoom', String(zoom)));
      }
      if (capabilities.torch) {
        let enabled = false;
        const light = button('Luz', async element => {
          await track.applyConstraints({ advanced: [{ torch: !enabled }] });
          enabled = !enabled; element.setAttribute('aria-pressed', String(enabled));
        });
        light.setAttribute('aria-pressed', 'false');
      }
      if (controls.childElementCount) this.cameraStatus.before(controls);
    }
    async releaseReader(reader) {
      try { await reader.stop(); }
      catch { this.stopTracks(); }
      this.readerElement.replaceChildren();
      if (this.reader === reader) this.reader = null;
    }
    stopTracks() {
      this.readerElement.querySelectorAll('video').forEach(video => {
        video.srcObject?.getTracks().forEach(track => track.stop());
      });
    }
    stopCamera() {
      this.cameraSequence++;
      this.cameraControls?.remove(); this.cameraControls = null;
      this.stopTracks();
      this.cameraTask = this.cameraTask.catch(() => {}).then(async () => {
        if (this.reader) await this.releaseReader(this.reader);
      });
    }
    closeScanner() {
      this.stopCamera();
      if (this.scannerDialog.open) this.scannerDialog.close();
      syncLock();
    }
    acceptCode(code) {
      this.closeScanner();
      this.input.value = String(code).trim(); this.input.focus();
      this.search(this.input.value, true);
    }
  }
  if (!customElements.get('casland-search')) customElements.define('casland-search', CaslandSearch);
})();